import { Component, OnInit } from '@angular/core';
import {Node,Link} from './../../../d3';

@Component({
  selector: 'app-link-analysis-example',
  templateUrl: './link-analysis-example.component.html',
  styleUrls: ['./link-analysis-example.component.scss']
})
export class LinkAnalysisExampleComponent implements OnInit {

  ngOnInit() {
  }


  nodes: Node[] = [];
  links: Link[] = [];

  constructor() {
    const N:number = 100,
          getIndex = number => number - 1;

    /** constructing the nodes array */
    for (let i = 1; i <= N; i++) {
      this.nodes.push(new Node(i.toString()));
    }

    for (let i = 1; i <= N; i++) {
      for (let m = 2; i * m <= N; m++) {
        /** increasing connections toll on connecting nodes */
        this.nodes[getIndex(i)].linkCount++;
        this.nodes[getIndex(i * m)].linkCount++;

        /** connecting the nodes before starting the simulation */
        this.links.push(new Link(i, i * m));
      }
    }
  }
}



